import * as tslib_1 from "tslib";
import createCache from '@emotion/cache';
import isPropValid from '@emotion/is-prop-valid';
import { serializeStyles } from '@emotion/serialize';
import { getRegisteredStyles, insertStyles } from '@emotion/utils';
import { m } from '../hyperscript';
import { createContext } from '../ui/context';
var EmotionCacheContext = createContext(createCache());
var concatClasses = function (classes) {
    return classes.filter(function (v) { return v; }).join(' ');
};
var addClasses = function (attrs) {
    var rest = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        rest[_i - 1] = arguments[_i];
    }
    var c1 = attrs.class, c2 = attrs.className, props = tslib_1.__rest(attrs, ["class", "className"]);
    return tslib_1.__assign({}, props, { class: concatClasses([c1, c2].concat(rest)) });
};
var filterProps = function (props) {
    var res = {};
    for (var key in props)
        if (isPropValid(key))
            res[key] = props[key];
    return res;
};
export var styled = function (tag) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = (isReal && tag.__emotion_base) || tag;
    return function () {
        var args = arguments;
        var styles = [];
        var name = (typeof tag === 'string' && tag) ||
            (tag.name !== 'component' && tag.name) ||
            tag.displayName;
        if (name)
            styles.push("label:" + name + ";");
        if (args[0] == null || args[0].raw === undefined) {
            styles.push.apply(styles, args);
        }
        else {
            styles.push(args[0][0]);
            var len = args.length;
            for (var i = 1; i < len; i++) {
                styles.push(args[i], args[0][i]);
            }
        }
        var component = function (_a) {
            var children = _a.children, extra = _a.className, attrs = tslib_1.__rest(_a, ["children", "className"]);
            return (m(EmotionCacheContext.Consumer, null, function (cache) {
                var className = '';
                var classInterpolations = [];
                if (typeof extra === 'string') {
                    className += getRegisteredStyles(cache.registered, classInterpolations, extra);
                }
                // Todo: typescript typings are wrong, first two arguments are switched
                var serialized = serializeStyles(styles.concat(classInterpolations), cache.registered, attrs);
                var rules = insertStyles(cache, serialized, typeof tag === 'string');
                className += cache.key + "-" + serialized.name;
                var props = typeof tag === 'string'
                    ? filterProps(addClasses(attrs, className))
                    : addClasses(attrs, className);
                var View = typeof tag === 'string' && attrs.as ? attrs.as : tag;
                return m(View, tslib_1.__assign({}, props), children);
            }));
        };
        var Styled = component;
        if (name)
            Styled.displayName = name;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        return Styled;
    };
};
